import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons"
import { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import { producttypeActions } from "../../../../../store/producttype-slice"
import InfoIcon from "../../../../InfoIcon"

const Resort = (props) => {
    const { type } = props

    const { resort } = useFilter()
    let filteredproducttypes = useSelector((state) => state.producttype.filteredProducttypes)
    let producttypes=useSelector(state=>state.producttype.producttypes)

    let dispatch = useDispatch()


    return <Fragment>
        <InfoIcon style={{ cursor: 'pointer' }} icon={faArrowUp} onClick={() => {

            dispatch(producttypeActions.setFilteredItems(resort(filteredproducttypes??producttypes, type, 'ASC')))
        }} />
        <InfoIcon style={{ cursor: 'pointer' }} icon={faArrowDown} onClick={() => {
            dispatch(producttypeActions.setFilteredItems(resort(filteredproducttypes??producttypes, type, 'DESC')))
        }} />
    </Fragment>
}

export default Resort